<template>
  <v-app>
    <v-content>
      <!-- <router-view v-title="title" ></router-view> -->
    </v-content>
    <v-content>
      <v-card class="mx-auto content-personal" max-width="70%" style="padding:30px; margin:30px; padding-top: 0px; margin-top: -30px;" :flat='true'>
        <user-policy></user-policy>

      </v-card>
    </v-content>
  </v-app>
</template>
<script>
import UserPolicy from '../components/Common/UserPolicy.vue';

export default {
  name: 'Policy',
 
  data: () => ({}),
  components: {
    UserPolicy,
  },

};
</script>
